import "../Contact/Contact.css";
import {Link} from "react-router-dom";



const Contact = () => {
    return(
        <>
            <div className="Contact-img">
                <h1 className="contact-content">Contact Us</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><Link to={"/"}>Home</Link></li>
                        <li class="breadcrumb-item active" aria-current="page">Data</li>
                    </ol>
                </nav>
            </div>

            
        </>
    )
}

export default Contact;